module.exports = __webpack_public_path__ + "img/mall.ba1804a5.png";